module.exports = __webpack_public_path__ + "static/img/10.4b7b4e8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/8/1/sp/10.png
// module id = O0Do
// module chunks = 0